import { useContext } from 'react';
import { DiveContext } from '../../contexts/DiveContext';
import Headline from '../../../../shared-kernel/components/headline/Headline';
import Button from '../../../../shared-kernel/components/button/Button';
import Text from '../../../../shared-kernel/components/text/Text';
import Grid from '../../../../shared-kernel/components/grid/Grid';
import Column from '../../../../shared-kernel/components/grid/Column';

const Scenario = () => {
    const { dive, nextStep } = useContext(DiveContext);

    const clickHandler = () => {
        nextStep();
    };

    return (
        <Grid>
            <Column>
                <Headline type={'h1'} hasBorder={true}>
                    {dive?.scenario.title}
                </Headline>
            </Column>

            <Column columns={6}>
                <Text asMarkdown={true}>
                    {dive?.scenario.text}
                </Text>
                <Button buttonType={'fillup'} onClick={clickHandler}>
                    {dive?.scenario.buttonText}
                </Button>
            </Column>

            <Column columns={6}>
                {dive?.scenario.image && <img className={'resized-img'} src={dive?.scenario.image} alt={''} />}
                {dive?.scenario.additionalText && <Text asMarkdown={true}>{dive?.scenario.additionalText}</Text>}
            </Column>

        </Grid>
    );
};

export default Scenario;
